'use strict';
/*
  Tabset and Tab directives
  i.e.
    <tabset>
        <tab heading="Tab1"> ... </tab>
        ...
    </tabset>
*/
namespace TR {

    const isMobile: boolean = TRPCONFIG.DeviceCategory === 'Phone';

    class Tabset {

        nextIndex: number = 0;
        tabs: Tab[] = [];
        activeTabId: string;
        qsTags: {};
        denyAnim: boolean = false;
        denyInitActivation: string;
        externalTriggers: string;
        minTabs: string;

        constructor (
            private $scope: ng.IScope,
            private $element: JQuery,
            private $location: ng.ILocationService,
            private cmsUtils
        ) {
            this.qsTags = this.$location.search();
            // Add placeholders to avoid very wide tabs
            let minTabs = this.minTabs ? parseInt(this.minTabs, 10) : 3;

            while (minTabs--) {
                let placeholder = new Tab();
                placeholder.isPlaceholder = true;
                this.tabs.push(placeholder);
            }

            if (this.externalTriggers === 'true') {
                $scope.$watch(() => this.activeTabId, val => {
                    if (val) {
                        let foundTab = _.find(this.tabs, tab => tab.tabId === val);
                        if (foundTab) {
                            this.select(foundTab);
                        }
                    }
                });
            }

        }

        // Don't open tab automatically on mobile, but inherit from attributes
        private _isDeniedInitActivation() {
            if (this.hasOwnProperty('denyInitActivation')) {
                return this.denyInitActivation === 'true';
            }
            return isMobile;
        }

        addTab (tab: Tab): void {
            let index = this.nextIndex++;

            if (this.tabs[index]) { // Contains a placeholder
                this.tabs[index] = tab; // Overwrite

                if (!this._isDeniedInitActivation() && index === 0) {
                    tab.active = true;
                }
            }
            else {
                this.tabs.push(tab);
            }

            // Select tab if `productOption` attr is matched in query string
            if (!this._isDeniedInitActivation() && this.isActiveProductOption(tab.productOption)) {
                this.select(tab);
            }
        }

        isActiveProductOption (productOption: {}): boolean {
            return this.cmsUtils.propsMatch(this.qsTags, productOption);
        }

        select (selectedTab: Tab): void {
            angular.forEach(this.tabs, tab => {
                if (tab.active && tab !== selectedTab) {
                    tab.active = false;
                }
            });
            selectedTab.active = true;
            this.activeTabId = selectedTab.tabId;
        }

    }

    class Tab {
        active: boolean = false;
        tabId: string;
        productOption: any; // For activating tab when product options change
        parentCtrl: Tabset;
        isPlaceholder: boolean = false;
        icon: string;

        constructor (
            private broker?,
            private cmsUtils?
        ) {
            // Sync tabs to attractions product form on desktop only
            if (!isMobile && this.productOption) {
                this.broker.subscribe(
                    'tab' + angular.toJson(this.productOption),
                    'attractionsProductUpdate',
                    _.debounce(e => {
                        if (this.cmsUtils.propsMatch(e.data, this.productOption)) {
                            this.show(null, true, true, true);
                        }
                    }, 100)
                );
            }
        }

        show (
            event,
            noAnim: boolean = false, // Only applies in accordion view
            noClose: boolean = false,
            noPublish: boolean = false // Avoid infinite loop from other events
        ): void {
            if (event) {
                event.preventDefault();
            }
            if (!this.isPlaceholder) {
                this.parentCtrl.denyAnim = noAnim;

                if (!noClose && this.active) {
                    this.active = false;
                }
                else {
                    this.parentCtrl.select(this);
                    if (!noPublish && this.productOption) {
                        this.broker.publish('tabProductOptionSelected', this.productOption);
                    }
                }
            }
        }
    }


    angular
        .module('TR')
        .directive('tabset', (): ng.IDirective => {
            return {
                restrict: 'E',
                transclude: true,
                replace: true,
                scope: {},
                controller: Tabset,
                controllerAs: 'ts',
                bindToController: {
                    headline: '@',
                    externalTriggers: '@',
                    templateOverride: '@',
                    minTabs: '@',
                    activeTabId: '=?',
                    denyInitActivation: '@?'
                },
                templateUrl: (element, attrs) =>
                    'partials/home/directivetemplate?type=' + (attrs.templateOverride || 'TabSet'),
            };
        })
        .directive('tab', ($timeout: ng.ITimeoutService): ng.IDirective => {
            return {
                restrict: 'E',
                transclude: true,
                replace: true,
                scope: {},
                controller: Tab,
                controllerAs: 'tb',
                require: '^tabset',
                bindToController: {
                    heading: '@',
                    imageUrl: '@',
                    tabId: '@',
                    productOption: '=',
                    icon: '@',
                    eventCategory: '@',
                    eventAction: '@',
                    eventLabel: '@'
                },
                templateUrl: 'partials/home/directivetemplate?type=Tab',
                link: (
                    scope: any,
                    el: JQuery,
                    attr: ng.IAttributes,
                    tabsetCtrl: Tabset
                ) => {
                    scope.tb.parentCtrl = tabsetCtrl;
                    tabsetCtrl.addTab(scope.tb);

                    // Accordion animation
                    $timeout(() => {
                        const inlineTabBtn: JQuery = el.find('.tab-button-inline'),
                            contentEl: JQuery = el.find('.tab-content');

                        if (contentEl.length) {
                            scope.$watch('tb.active', isActive => {
                                let isAnim = inlineTabBtn.is(':visible') && !tabsetCtrl.denyAnim;

                                if (isAnim) {
                                    contentEl.animate(
                                        {height: isActive ? contentEl[0].scrollHeight : 0},
                                        120,
                                        isActive ? () => {
                                            let tabTop = inlineTabBtn.offset().top;

                                            // Set height back to 'auto' after expand anim
                                            contentEl.height('auto');

                                            // Ensure tab is on screen (also customer for any sticky elements)
                                            let stickyOffset = $('.sticky-wrapper').toArray().reduce((offset, el) =>
                                                Math.max($(el).outerHeight(), offset), 0);

                                            /// On mobile we need to take into customer also the fixed header.
                                            const $header = $('.header-main');
                                            let headerOffset = 0;
                                            if ('fixed' === $header.css('position')) {
                                                headerOffset = $header.outerHeight();
                                            }

                                            if(tabTop < $(document).scrollTop() + stickyOffset + headerOffset) {
                                                $(document).scrollTop(tabTop - stickyOffset - headerOffset);
                                            }
                                        } : undefined);
                                }
                                else {
                                    contentEl.height(isActive ? 'auto' : 0);
                                }
                            });
                        }
                    });
                }
            };
        });

}
